<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="section">
    <div class="sectionHeader">
      <div class="title">
        <div class="label">{{ "VEHICLE.vehicleDashboard" | translate }}</div>
      </div>
    </div>

    <div class="sectionBody">
      <div class="dashboard-cards">
        <mat-card class="dashboard-card">
          <mat-card-content class="dashboard-card-content">
            <div class="card-title">Total Vehicles</div>
            <div class="card-value">{{ totalVehicles }}</div>
            <div class="card-subtitle">All time</div>
          </mat-card-content>
        </mat-card>

        <mat-card class="dashboard-card">
          <mat-card-content class="dashboard-card-content">
            <div class="card-title">Total Freight Value</div>
            <div class="card-value">₹{{ totalFreightValue }}</div>
            <div class="card-subtitle">All time</div>
          </mat-card-content>
        </mat-card>

        <mat-card class="dashboard-card">
          <mat-card-content class="dashboard-card-content">
            <div class="card-title">Average Freight Rate</div>
            <div class="card-value">₹{{ averageFreightRate || 0 }}</div>
            <div class="card-subtitle">Per vehicle</div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="shipment-records">
        <div class="shipment-records-actions">
          <!-- <mat-form-field appearance="outline">
            <mat-label>Search shipments...</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event.target.value)"
              #input
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field> -->

          <!-- <div class="date-range-export">
            <button mat-stroked-button class="date-range-button">
              <mat-icon>date_range</mat-icon> Select date range
            </button>
            <button mat-stroked-button class="export-button">
              <mat-icon>cloud_download</mat-icon> Export
            </button>
          </div> -->
        </div>

        <div class="from-to-date">
          <!-- From Date Input -->
          <div class="formInput">
            <mat-label class="form-label">From</mat-label>
            <input class="form-control-input-box" type="text"
            name="fromDate"
            [matDatepicker]="picker"
            [(ngModel)]="fromDate" 
            (click)="picker.open()"
            (dateChange)="fromDateHandler($event)"
            [max]="today" 
            readonly 
            />
            <mat-datepicker #picker></mat-datepicker>
          </div>

          <!-- To Date Input -->
          <div class="formInput">
            <mat-label class="form-label">To</mat-label>
            <input class="form-control-input-box" type="text" 
            name="toDate"
            [matDatepicker]="pickerto"
            [(ngModel)]="toDate" 
            (click)="pickerto.open()"
            (dateChange)="toDateHandler($event)"
            [max]="today" 
            readonly 
            />
            <mat-datepicker #pickerto></mat-datepicker>
          </div>

          <!-- Search Button for DO and Invoice -->
          <div class="formInput">
            <label class="form-label">Search</label>
            <input
              class="form-control-input-box"
              type="text"
              (keyup)="applyFilterField($event.target.value)"
              #input
              placeholder="Search by DO or Invoice"
            />
          </div>
        </div>

        <div class="table-container">
          <!-- <div class="table-settings">
            <div class="show-entries">
              Show
              <mat-form-field appearance="fill">
                <mat-select
                  [value]="pageSize"
                  (selectionChange)="handlePageEvent({ pageSize: $event.value, pageIndex: 0, length: shipmentRecords.length })"
                >
                  <mat-option *ngFor="let size of pageSizeOptions" [value]="size">
                    {{ size }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              entries
            </div>
          </div> -->

          <!-- <mat-paginator
            [pageSizeOptions]="pageSizeOptions"
            showFirstLastButtons
            [pageSize]="pageSize"
            [length]="shipmentRecords.length"
          ></mat-paginator> -->

          <table mat-table [dataSource]="dataSource" matSort class="">

            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
              <td mat-cell *matCellDef="let row">{{ row.sno }}</td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
              <td mat-cell *matCellDef="let row">{{ row.date }}</td>
            </ng-container>

            <ng-container matColumnDef="destination">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Destination
              </th>
              <td mat-cell *matCellDef="let row">{{ row.destination }}</td>
            </ng-container>

            <!-- <ng-container matColumnDef="vehicleNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Vehicle Number
              </th>
              <td mat-cell *matCellDef="let row">{{ row.vehicleNumber }}</td>
            </ng-container> -->

            <ng-container matColumnDef="doNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                DO Number
              </th>
              <td mat-cell *matCellDef="let row">{{ row.doNumber }}</td>
            </ng-container>

            <ng-container matColumnDef="invoiceNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Invoice Number
              </th>
              <td mat-cell *matCellDef="let row">{{ row.invoiceNumber }}</td>
            </ng-container>

            <ng-container matColumnDef="pickup">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Pickup
              </th>
              <td mat-cell *matCellDef="let row">{{ row.pickup }}</td>
            </ng-container>

            <ng-container matColumnDef="freightRate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Freight Rate (MT)
              </th>
              <td mat-cell *matCellDef="let row">{{ row.freightRate }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="6">
                No data matching the filter "{{ input.value }}"
              </td>
            </tr>
          </table>

          <!-- <div class="table-pagination-summary">
            Showing {{ (paginator.pageIndex * paginator.pageSize) + 1 }} to
            {{ (paginator.pageIndex * paginator.pageSize) + paginator.pageSize > shipmentRecords.length ? shipmentRecords.length : (paginator.pageIndex * paginator.pageSize) + paginator.pageSize }} of
            {{ shipmentRecords.length }} entries
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>